import { PictureLodging } from "../../../"
import { PrestationContent } from "../../../"

export class LiheContentResponseDTO {
    liheId: number
    liheName: string
    stationId: string
    stationName: string
    pictureLodging: PictureLodging[]
    prestations: PrestationContent[]
    distanceToSkishop: string
    providerSkiShopName: string
    providerId: string
    countryId: string
    countryName: string
    regionId: string
    regionName: string
    criterias: string[]
    constructor(
        liheId: number,
        liheName: string,
        stationId: string,
        stationName: string,
        pictureLodging: PictureLodging[],
        prestations: PrestationContent[],
        distanceToSkishop: string,
        providerSkiShopName: string,
        providerId: string,
        countryId: string,
        countryName: string,
        regionId: string,
        regionName: string,
        criterias: string[],
    ) {
        this.liheId = liheId
        this.liheName = liheName
        this.stationId = stationId
        this.stationName = stationName
        this.pictureLodging = pictureLodging
        this.prestations = prestations
        this.distanceToSkishop = distanceToSkishop
        this.providerSkiShopName = providerSkiShopName
        this.providerId = providerId
        this.countryId = countryId
        this.countryName = countryName
        this.regionId = regionId
        this.regionName = regionName
        this.criterias = criterias
    }
}

export const buildLiheContentResponseDTO = (obj: any): LiheContentResponseDTO => {
    return new LiheContentResponseDTO(
        obj.liheId,
        obj.liheName,
        obj.stationId,
        obj.stationName,
        obj.pictureLodging,
        obj.prestations,
        obj.distanceToSkishop,
        obj.providerSkiShopName,
        obj.providerId,
        obj.countryId,
        obj.countryName,
        obj.regionId,
        obj.regionName,
        obj.criterias,
    )
}